import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { Field, reduxForm } from 'redux-form';
import { modal } from 'react-redux-modal';
import validate from './validate';
import { renderField, renderTextarea } from '../../../utils/renderFields';
import { submitPartnerMessage } from '../../../actions/globalConfig';
import { FeedbackModal } from '../../index';

const propTypes = {
  removeModal: PropTypes.func,
}

const defaultProps = {
  removeModal: () => {},
  initialValues: {
    referer: '',
    browserInfo: '',
  }
}

class MessagePartnerFormMarkup extends React.Component {

  constructor(props){
    super(props);
    this.submit = this.submit.bind(this);
    this.onFeedback = this.onFeedback.bind(this);
  }

  submit(values) {
    return this.props.dispatch(submitPartnerMessage(values));
  }

  onFeedback(e) {
    this.props.removeModal(e);
    modal.add(FeedbackModal, { size: 'medium', hideTitleBar: true });
  }

  render(){
    const { error, handleSubmit, submitting, submitSucceeded, partnerTitle } = this.props;

    return(
      <div className="p-20" id="feedback-form-content">
        {!submitting && !submitSucceeded &&
          <span>
            <p>
              Send a message directly to {partnerTitle}! When composing your message, be sure to abide by all
              of our community guidelines.
            </p>
            <p>
              <strong>
                ATTENTION: If you are messaging because of a website or commenting issue,&nbsp;
                <Link to="/help" onClick={e => this.props.removeModal(e)}>please read our FAQ page.</Link>&nbsp;
                If your question is not answered in the FAQ,&nbsp;
                <a href="#" onClick={this.onFeedback}>use the Feedback form</a> to message Explore about the issue.
              </strong>
            </p>
          </span>
        }

        <form onSubmit={handleSubmit(this.submit)}>
          <span className={error ? 'has-danger' : ''}>
            <span className="u-fontSize-11 form-control-feedback">{error}</span>
          </span>

          {submitSucceeded && !submitting &&
            <div className="text-center">
              <p>Your message has been sent!</p>
              <div><button className="btn btn-cancel" onClick={(e)=>{this.props.removeModal(e)}}>Close</button></div>
            </div>
          }

          {submitting && !submitSucceeded &&
            <div className="text-center">
              <p>Sending message...</p>
            </div>
          }

          {!submitting && !submitSucceeded &&
            <div>
              <Field component={renderField} name="name" type="text" label="name" className="form-control" />
              <Field component={renderField} name="email" type="email" label="email" className="form-control" />
              <Field component={renderField} name="subject" type="text" label="subject" className="form-control" />
              <Field component={renderTextarea} name="body" type="textarea" label="share your thoughts." className="form-control" />
              <Field component="input" type="hidden" name="partner_id" />

              <div className="d-flex justify-content-between">
                <div><button className="btn btn-cancel" onClick={(e)=>{this.props.removeModal(e)}}>Cancel</button></div>
                <div><input type="submit" value="Send" id="submit" className="btn btn-primary" disabled={submitting} /></div>
              </div>
            </div>
          }

        </form>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    removeModal: ownProps.removeModal,
    initialValues: {
      partner_id: ownProps.partnerId,
      livecam_id: ownProps.livecamId,
    },
  };
};

const MessagePartnerForm = reduxForm({
  form: 'message-partner',
  validate,
  fields: [
    'name',
    'email',
    'subject',
    'body',
  ],
})(MessagePartnerFormMarkup);

MessagePartnerFormMarkup.propTypes = propTypes;
MessagePartnerFormMarkup.defaultProps = defaultProps;

export default connect(mapStateToProps)(MessagePartnerForm);
